const DataCatalogService = () => import('Views/dataCatalog/index-new-ui');
const DataCatalogList = () => import('Views/dataCatalog/data-catalog-list');
const DataCatalogAddEdit = () => import('Views/dataCatalog/data-catalog-addEdit');
const DirKeeperList = () => import('Views/dataCatalog/dir-keeper-list');
const DisciplineGroupList = () => import('Views/dataCatalog/disciplineGroupSpace/discipline-group-list');
const DisciplineGroupSpaceDetail = () => import('Views/dataCatalog/disciplineGroupSpace/discipline-group-space-detail');
const DisciplineGroupSpaceAddEdit = () => import('Views/dataCatalog/disciplineGroupSpace/discipline-group-space-addEdit');

export default[
  { path: '/dataCatalog', component: DataCatalogService },
  { path: '/data-catalog-list/:id', component: DataCatalogList },
  { path: '/data-catalog-add', component: DataCatalogAddEdit },
  { path: '/data-catalog-edit/:id', component: DataCatalogAddEdit },
  { path: '/dir-keeper-list', component: DirKeeperList },
  { path: '/discipline-group-list', component: DisciplineGroupList },
  { path: '/discipline-group-space-detail/:id', component: DisciplineGroupSpaceDetail },
  { path: '/discipline-group-space-add/:id', component: DisciplineGroupSpaceAddEdit },
];



// WEBPACK FOOTER //
// ./src/router/dataCatalog.js